import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/search/queue_list.png';
import _imports_1 from '@/assets/icon/time_ic.png';
import _imports_2 from '@/assets/icon/icon_calendar.svg';
import _imports_3 from '@/assets/icon/search/clock_icon.png';
import _imports_4 from '@/assets/icon/search/live_ing.gif';
const _withScopeId = n => (_pushScopeId("data-v-139acd35"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "typeContainer" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "typeContainer allCourse" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "typeContainer subTypeWrapper" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "lecturerBox flex-c" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "lecturerInfo text-overflow" };
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = { class: "typeTitle" };
const _hoisted_15 = {
    key: 0,
    class: "titleAll flex"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "titleName" }, "课程", -1));
const _hoisted_17 = /*#__PURE__*/ _createTextVNode(" 共 ");
const _hoisted_18 = { class: "numberColor expert" };
const _hoisted_19 = /*#__PURE__*/ _createTextVNode("个");
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "iconRight" }, null, -1));
const _hoisted_21 = {
    key: 1,
    class: "font-24"
};
const _hoisted_22 = /*#__PURE__*/ _createTextVNode(" 找到");
const _hoisted_23 = { class: "font-w500 themeColor" };
const _hoisted_24 = /*#__PURE__*/ _createTextVNode("个课程 ");
const _hoisted_25 = ["onClick"];
const _hoisted_26 = { class: "imgBox" };
const _hoisted_27 = ["src"];
const _hoisted_28 = {
    key: 0,
    class: "type font-24"
};
const _hoisted_29 = { class: "info flex-1 border-box" };
const _hoisted_30 = ["innerHTML"];
const _hoisted_31 = { class: "teacher text-overflow font-28" };
const _hoisted_32 = ["innerHTML"];
const _hoisted_33 = ["innerHTML"];
const _hoisted_34 = { class: "bottom gray-9 font-24 flex" };
const _hoisted_35 = {
    key: 0,
    class: "flex"
};
const _hoisted_36 = { class: "listIcon bacF flex-c" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_38 = { class: "time bacF flex-c font-24" };
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_40 = {
    key: 1,
    class: "time bacF flex-c font-24"
};
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1));
const _hoisted_42 = { class: "typeTitle" };
const _hoisted_43 = {
    key: 0,
    class: "titleAll flex"
};
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "titleName font-24" }, "课程内容", -1));
const _hoisted_45 = /*#__PURE__*/ _createTextVNode(" 共 ");
const _hoisted_46 = { class: "numberColor expert" };
const _hoisted_47 = /*#__PURE__*/ _createTextVNode("个");
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "iconRight" }, null, -1));
const _hoisted_49 = {
    key: 1,
    class: "font-24"
};
const _hoisted_50 = /*#__PURE__*/ _createTextVNode(" 找到");
const _hoisted_51 = { class: "font-w500 themeColor" };
const _hoisted_52 = /*#__PURE__*/ _createTextVNode("个课程内容 ");
const _hoisted_53 = ["onClick"];
const _hoisted_54 = { class: "imgBox" };
const _hoisted_55 = ["src"];
const _hoisted_56 = {
    key: 0,
    class: "type font-24"
};
const _hoisted_57 = { class: "info flex-1 border-box" };
const _hoisted_58 = { class: "title text-ell2 font-32 wordLine" };
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "typeTip" }, "视频", -1));
const _hoisted_60 = /*#__PURE__*/ _createTextVNode("  ");
const _hoisted_61 = ["innerHTML"];
const _hoisted_62 = { class: "teacher text-overflow font-28" };
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "gray-6" }, "课程：", -1));
const _hoisted_64 = ["innerHTML"];
const _hoisted_65 = {
    key: 0,
    class: "teacher text-overflow font-28"
};
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "gray-6" }, "课节：", -1));
const _hoisted_67 = ["innerHTML"];
const _hoisted_68 = {
    key: 1,
    class: "mt-20",
    style: { "display": "inline-block" }
};
const _hoisted_69 = { class: "time bacF flex font-24" };
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_71 = { class: "typeTitle" };
const _hoisted_72 = {
    key: 0,
    class: "flex titleAll"
};
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "titleName font-24" }, "讲师", -1));
const _hoisted_74 = /*#__PURE__*/ _createTextVNode(" 共 ");
const _hoisted_75 = { class: "numberColor expert" };
const _hoisted_76 = /*#__PURE__*/ _createTextVNode("个");
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "iconRight" }, null, -1));
const _hoisted_78 = { key: 1 };
const _hoisted_79 = /*#__PURE__*/ _createTextVNode(" 找到 ");
const _hoisted_80 = { class: "font-w500 themeColor" };
const _hoisted_81 = /*#__PURE__*/ _createTextVNode(" 位讲师 ");
const _hoisted_82 = ["onClick"];
const _hoisted_83 = { class: "lecturerImg" };
const _hoisted_84 = ["src"];
const _hoisted_85 = { class: "info flex-1 border-box" };
const _hoisted_86 = { class: "lecturerTitle flex-c" };
const _hoisted_87 = { class: "text-overflow lecturerTitle-L" };
const _hoisted_88 = ["innerHTML"];
const _hoisted_89 = ["innerHTML"];
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "lecturerBtn font-w500 font-24" }, "讲师主页", -1));
const _hoisted_91 = ["innerHTML"];
const _hoisted_92 = { class: "typeTitle" };
const _hoisted_93 = {
    key: 0,
    class: "flex titleAll"
};
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "titleName font-24" }, "早读", -1));
const _hoisted_95 = /*#__PURE__*/ _createTextVNode(" 共 ");
const _hoisted_96 = { class: "numberColor expert" };
const _hoisted_97 = /*#__PURE__*/ _createTextVNode("个");
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "iconRight" }, null, -1));
const _hoisted_99 = { key: 1 };
const _hoisted_100 = /*#__PURE__*/ _createTextVNode(" 找到 ");
const _hoisted_101 = { class: "font-w500 themeColor" };
const _hoisted_102 = /*#__PURE__*/ _createTextVNode(" 篇文章 ");
const _hoisted_103 = ["onClick"];
const _hoisted_104 = { class: "imgBox" };
const _hoisted_105 = ["src"];
const _hoisted_106 = { class: "info flex-1 border-box" };
const _hoisted_107 = ["innerHTML"];
const _hoisted_108 = {
    key: 0,
    class: "teacher text-overflow font-28"
};
const _hoisted_109 = { class: "hospital gray-6" };
const _hoisted_110 = {
    key: 1,
    class: "bottom flex"
};
const _hoisted_111 = { class: "listIcon bacF flex" };
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_3,
    alt: ""
}, null, -1));
const _hoisted_113 = { class: "font-24" };
const _hoisted_114 = { class: "typeTitle" };
const _hoisted_115 = {
    key: 0,
    class: "titleAll flex"
};
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "titleName font-24" }, "直播", -1));
const _hoisted_117 = /*#__PURE__*/ _createTextVNode(" 共 ");
const _hoisted_118 = { class: "numberColor expert" };
const _hoisted_119 = /*#__PURE__*/ _createTextVNode("个");
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "iconRight" }, null, -1));
const _hoisted_121 = { key: 1 };
const _hoisted_122 = /*#__PURE__*/ _createTextVNode(" 找到 ");
const _hoisted_123 = { class: "font-w500 themeColor" };
const _hoisted_124 = /*#__PURE__*/ _createTextVNode(" 场直播 ");
const _hoisted_125 = ["onClick"];
const _hoisted_126 = { class: "imgBox liveImgbox" };
const _hoisted_127 = ["src"];
const _hoisted_128 = { class: "liveType font-24 flex-c" };
const _hoisted_129 = {
    key: 0,
    class: "liveIcon",
    src: _imports_4,
    alt: ""
};
const _hoisted_130 = { class: "info flex-1 border-box" };
const _hoisted_131 = ["innerHTML"];
const _hoisted_132 = { class: "teacher text-overflow font-28" };
const _hoisted_133 = ["innerHTML"];
const _hoisted_134 = ["innerHTML"];
const _hoisted_135 = {
    key: 0,
    class: "bottom font-24 flex"
};
const _hoisted_136 = { class: "listIcon bacF flex" };
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_3,
    alt: ""
}, null, -1));
const _hoisted_138 = { class: "typeTitle" };
const _hoisted_139 = {
    key: 0,
    class: "titleAll flex"
};
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "titleName font-24" }, "商城", -1));
const _hoisted_141 = /*#__PURE__*/ _createTextVNode(" 共 ");
const _hoisted_142 = { class: "numberColor expert" };
const _hoisted_143 = /*#__PURE__*/ _createTextVNode("个");
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "iconRight" }, null, -1));
const _hoisted_145 = { key: 1 };
const _hoisted_146 = /*#__PURE__*/ _createTextVNode(" 找到 ");
const _hoisted_147 = { class: "font-w500 themeColor" };
const _hoisted_148 = /*#__PURE__*/ _createTextVNode(" 个商品 ");
const _hoisted_149 = ["onClick"];
const _hoisted_150 = { class: "imgBox" };
const _hoisted_151 = ["src"];
const _hoisted_152 = { class: "info flex-1 border-box" };
const _hoisted_153 = ["innerHTML"];
const _hoisted_154 = { class: "mall-price flex" };
const _hoisted_155 = { class: "price font-32" };
const _hoisted_156 = { class: "original-price font-28" };
const _hoisted_157 = {
    key: 0,
    class: "vipPrice font-32"
};
const _hoisted_158 = { class: "noMore" };
import { getTab, getCourse, getCourseContent, getReadList, getLiveList, getMallList, getLecturerList, getLecturerDetail } from '@api/search';
import Empty from '@/components/common/Empty.vue';
import BetterScroll from '@/components/common/BetterScroll.vue';
import { getDomWidth, appPort, jumpModuleApp, goToStudy } from '@/widget';
import { ref, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { hostPath } from '@/public/utils/basePath';
import FeedBack from '@/views/search/components/FeedBack.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        searchText: {
            type: String || undefined,
            default: ''
        }
    },
    emits: ['saveSearchData'],
    setup(__props, { expose, emit: emits }) {
        const props = __props;
        const router = useRouter();
        const route = useRoute();
        // 计算要滚动的距离
        const countLeft = (className) => {
            if (!className) {
                return 0;
            }
            let parent = document.querySelector('.' + className);
            let child = document.querySelector('.' + className + ' .active');
            if (!parent || !child) {
                return 0;
            }
            // 父元素宽度
            let pw = parent?.offsetWidth;
            let cw = child?.offsetWidth;
            let cw2 = parseInt(cw / 2 + '', 10);
            let cl = child?.offsetLeft;
            let cr = pw - cw - cl; // 元素距离右侧距离
            let ww = window.innerWidth;
            let ww2 = parseInt(ww / 2 + '', 10);
            // debugger
            if (ww2 > cw2 + cl || pw < ww) {
                return 0;
            }
            else if (cr < ww2) {
                return ww - pw;
            }
            else {
                return ww2 - (cl + cw2);
            }
        };
        // let localData = localStorage.getItem('searchData') || ''
        // const searchData = localData ? JSON.parse(localData) : ''
        const searchModule = ref(route.query?.module || '');
        const searchCourse = ref(route.query?.type || '');
        const searchDetail = ref(route.query?.detail || '');
        // if (searchData) {
        //   let { module, type, detail } = searchData
        //   if (module && !searchModule.value) {
        //     searchModule.value = module
        //   }
        //   if (type && !searchCourse.value) {
        //     searchCourse.value = type
        //   }
        //   if (detail && !searchDetail.value) {
        //     searchDetail.value = detail
        //   }
        // }
        const courseDom = ref();
        const tabDom = ref();
        const detailDom = ref();
        const tabW = ref(7.5);
        const courseW = ref(7.5);
        const detailW = ref(7.5);
        const vipBs = ref();
        const courseBs = ref();
        const detailBs = ref();
        const listRef = ref();
        const loaded = ref(false);
        let total = ref(0);
        const tabHeight = ref(0.7);
        const options = {
            scrollY: false,
            scrollX: true,
            click: true,
            mouseWheel: false,
            scrollbar: {
                fade: false,
                interactive: true
            }
        };
        const courseData = ref({});
        const courseContent = ref({});
        const articleData = ref({});
        const liveData = ref({});
        const mallData = ref({});
        const lecturerData = ref({});
        const lecturerInfo = ref({});
        const tabList = ref([]);
        const courseTabList = ref([]);
        // const courseList = ref<any[]>([])
        const detailList = ref([]);
        const isEmpty = ref(true);
        const isLoaded = ref(false);
        const noMore = ref(false);
        const depId = Number(route.query.depId || localStorage.getItem('search_depid') || 1);
        var pageNo = 1;
        var pageCount = 1;
        watch(() => tabList.value, () => {
            nextTick(() => {
                tabW.value = getDomWidth(tabDom.value, 68, 32);
                vipBs.value?.refreshBs();
                getDatas(true);
            });
        });
        /* 更新路由参数 */
        const addQuery = () => {
            emits('saveSearchData', {
                module: searchModule.value,
                type: searchCourse.value,
                detail: searchDetail.value
            });
        };
        const showFeed = ref(false); // 是否显示反馈按钮
        const getDatas = async (bl) => {
            addQuery();
            if (!bl) {
                // 上拉加载时显示反馈按钮
                showFeed.value = true;
            }
            if (noMore.value && !bl) {
                return;
            }
            /* this.loading = true */
            if (bl) {
                pageNo = 1;
            }
            total.value = 0;
            isLoaded.value = false;
            noMore.value = false;
            if (searchModule.value === 'COURSE') {
                await getCourseList();
            }
            else if (searchModule.value === 'COURSE_CONTENT') {
                await getContentList();
            }
            else if (searchModule.value === 'READING') {
                await getRead();
            }
            else if (searchModule.value === 'LIVE') {
                await getLive();
            }
            else if (searchModule.value === 'PRODUCT') {
                await getMall();
            }
            else if (searchModule.value === 'EXPERT') {
                await getLecturer();
            }
            else {
                await getCourseList(1);
                await getContentList(1);
                await getRead(1);
                await getLive(1);
                await getMall(1);
                await getLecturer(1);
                await lecturerDetail();
                noMore.value = true;
            }
            if (searchModule.value) {
                if (total.value < 10) {
                    // 搜索结果小于 10 条、或空时显示反馈
                    showFeed.value = true;
                }
                else {
                    showFeed.value = false;
                }
            }
            else if (isEmpty.value) {
                showFeed.value = true;
            }
            nextTick(() => {
                isLoaded.value = true;
                if (bl) {
                    listRef.value?.scrollTo(0, 0, 300);
                }
            });
        };
        /* 切换tab */
        const moduleSearch = value => {
            detailList.value = [];
            searchCourse.value = '';
            searchDetail.value = '';
            if (value.navigationTypeName) {
                if (value.navigationType == searchModule.value) {
                    return;
                }
                courseTabList.value = [];
                searchModule.value = value.navigationType;
                if (value.navigations.length > 0) {
                    courseTabList.value = [
                        { navigationTypeName: '全部', navigationType: '', navigations: [] },
                        ...value.navigations
                    ];
                    courseW.value = 7.5;
                    tabHeight.value = 1.5;
                    nextTick(() => {
                        courseW.value = getDomWidth(courseDom.value, 68, 32);
                        courseBs.value?.refreshBs();
                    });
                }
                else {
                    getDomWidth;
                    tabHeight.value = 0.7;
                }
                getDatas(true);
            }
            else {
                searchModule.value = value;
                if (['COURSE', 'COURSE_CONTENT'].includes(value)) {
                    tabData();
                }
                else {
                    getDatas(true);
                }
            }
            nextTick(() => {
                vipBs.value.scrollTo(countLeft('typeList'), 0);
            });
        };
        /* 讲师名精准搜索 */
        const lecturerDetail = () => {
            getLecturerDetail({
                departmentId: depId,
                target: props.searchText
            }).then(res => {
                if (res.code == 200) {
                    lecturerInfo.value = res.data;
                    listRef.value.refreshBs();
                }
            });
        };
        /* 课程分类 */
        const courseSearch = value => {
            detailList.value = [];
            searchDetail.value = '';
            searchCourse.value = value.navigationType;
            if (value.navigations.length > 0) {
                detailList.value = [
                    { navigationTypeName: '全部', navigationType: '', navigations: [] },
                    ...value.navigations
                ];
                detailW.value = 7.5;
                tabHeight.value = 2.3;
                nextTick(() => {
                    detailW.value = getDomWidth(detailDom.value, 68);
                    detailBs.value?.refreshBs();
                });
            }
            else {
                tabHeight.value = 1.5;
            }
            getDatas(true);
        };
        const detailSearch = value => {
            searchDetail.value = value.navigationType;
            getDatas(true);
            nextTick(() => {
                detailBs.value.scrollTo(countLeft('subTypeList'), 0);
            });
        };
        /* 获取tab数据 */
        const tabData = () => {
            getTab().then((res) => {
                if (res.code == 200) {
                    const data = res.data;
                    if (data.length > 0) {
                        tabList.value = [
                            { navigationTypeName: '全部', navigationType: '', navigations: [] },
                            ...data
                        ];
                        if (['COURSE', 'COURSE_CONTENT'].includes(searchModule.value)) {
                            const findCourse = tabList.value.find(item => item.navigationType === searchModule.value);
                            courseTabList.value = [
                                { navigationTypeName: '全部', navigationType: '', navigations: [] },
                                ...findCourse.navigations
                            ];
                            tabHeight.value = 1.5;
                            if (searchCourse.value) {
                                const findDetail = courseTabList.value.find(item => item.navigationType === searchCourse.value);
                                if (findDetail.navigations.length > 0) {
                                    detailList.value = [
                                        {
                                            navigationTypeName: '全部',
                                            navigationType: '',
                                            navigations: []
                                        },
                                        ...findDetail.navigations
                                    ];
                                }
                                nextTick(() => {
                                    detailW.value = getDomWidth(detailDom.value, 68);
                                    detailBs.value?.refreshBs();
                                });
                                if (searchDetail.value || detailList.value.length > 0) {
                                    tabHeight.value = 2.3;
                                    searchDetail.value = String(searchDetail.value || '');
                                }
                            }
                        }
                        nextTick(() => {
                            setTimeout(() => {
                                vipBs.value.scrollTo(countLeft('typeList'), 0);
                            }, 300);
                        });
                    }
                }
            });
        };
        tabData();
        /* const getDatas = () => {
          getCourseList()
        } */
        /* 获取课程数据 */
        const getCourseList = (nums) => {
            return new Promise((resolve, reject) => {
                isEmpty.value = true;
                getCourse({
                    stepType: searchModule.value ? 'STEP10' : 'STEP2',
                    target: props.searchText,
                    departmentId: depId,
                    navigationType: (searchDetail.value
                        ? searchDetail.value
                        : searchCourse.value
                            ? searchCourse.value
                            : searchModule.value) || 'COURSE',
                    page: pageNo
                })
                    .then((res) => {
                    resolve(true);
                    if (res.code === 200) {
                        total.value = res.data.total;
                        pageCount = res.data.pages;
                        if (pageNo == 1) {
                            courseData.value = res.data;
                        }
                        else {
                            courseData.value.items = courseData.value.items.concat(res.data.items);
                        }
                        if (pageCount > pageNo && !nums) {
                            pageNo++;
                            noMore.value = false;
                        }
                        else {
                            noMore.value = true;
                        }
                        if (total.value > 0) {
                            isEmpty.value = false;
                        }
                    }
                })
                    .catch(() => {
                    reject();
                });
            });
        };
        /* 获取课程内容数据 */
        const getContentList = (nums) => {
            return new Promise((reslove, reject) => {
                getCourseContent({
                    stepType: searchModule.value ? 'STEP10' : 'STEP2',
                    target: props.searchText,
                    departmentId: depId,
                    navigationType: (searchDetail.value
                        ? searchDetail.value
                        : searchCourse.value
                            ? searchCourse.value
                            : searchModule.value) || 'COURSE_CONTENT',
                    page: pageNo
                }).then(res => {
                    reslove(true);
                    if (res.code === 200) {
                        pageCount = res.data.pages;
                        total.value = res.data.total;
                        if (pageNo == 1) {
                            courseContent.value = res.data;
                        }
                        else {
                            courseContent.value.items = courseContent.value.items.concat(res.data.items);
                        }
                        if (pageCount > pageNo && !nums) {
                            pageNo++;
                            noMore.value = false;
                        }
                        else {
                            noMore.value = true;
                        }
                        if (total.value > 0) {
                            isEmpty.value = false;
                        }
                    }
                });
            });
        };
        /* 早读 */
        const getRead = (nums) => {
            return new Promise((reslove, reject) => {
                getReadList({
                    stepType: searchModule.value ? 'STEP10' : 'STEP2',
                    target: props.searchText,
                    departmentId: depId,
                    navigationType: searchModule.value || 'READING',
                    page: pageNo
                }).then(res => {
                    reslove(true);
                    if (res.code === 200) {
                        total.value = res.data.total;
                        pageCount = res.data.pages;
                        if (pageNo == 1) {
                            articleData.value = res.data;
                        }
                        else {
                            articleData.value.items = articleData.value.items.concat(res.data.items);
                        }
                        if (pageCount > pageNo && !nums) {
                            pageNo++;
                            noMore.value = false;
                        }
                        else {
                            noMore.value = true;
                        }
                        if (total.value > 0) {
                            isEmpty.value = false;
                        }
                    }
                });
            });
        };
        /* 直播 */
        const getLive = (nums) => {
            return new Promise((reslove, reject) => {
                getLiveList({
                    stepType: searchModule.value ? 'STEP10' : 'STEP2',
                    target: props.searchText,
                    departmentId: depId,
                    navigationType: searchModule.value || 'LIVE',
                    page: pageNo
                }).then(res => {
                    reslove(true);
                    if (res.code === 200) {
                        total.value = res.data.total;
                        pageCount = res.data.pages;
                        if (pageNo == 1) {
                            liveData.value = res.data;
                        }
                        else {
                            liveData.value.items = liveData.value.items.concat(res.data.items);
                        }
                        if (pageCount > pageNo && !nums) {
                            pageNo++;
                            noMore.value = false;
                        }
                        else {
                            noMore.value = true;
                        }
                        if (total.value > 0) {
                            isEmpty.value = false;
                        }
                    }
                });
            });
        };
        /* 商城 */
        const getMall = (nums) => {
            return new Promise((reslove, reject) => {
                getMallList({
                    stepType: searchModule.value ? 'STEP10' : 'STEP2',
                    target: props.searchText,
                    departmentId: depId,
                    navigationType: searchModule.value || 'PRODUCT',
                    page: pageNo
                }).then(res => {
                    reslove(true);
                    if (res.code === 200) {
                        total.value = res.data.total;
                        pageCount = res.data.pages;
                        if (pageNo == 1) {
                            mallData.value = res.data;
                        }
                        else {
                            mallData.value.items = mallData.value.items.concat(res.data.items);
                        }
                        if (pageCount > pageNo && !nums) {
                            pageNo++;
                            noMore.value = false;
                        }
                        else {
                            noMore.value = true;
                        }
                        if (total.value > 0) {
                            isEmpty.value = false;
                        }
                    }
                });
            });
        };
        /* 讲师 */
        const getLecturer = (nums) => {
            return new Promise((reslove, reject) => {
                getLecturerList({
                    stepType: searchModule.value ? 'STEP10' : 'STEP2',
                    target: props.searchText,
                    departmentId: depId,
                    page: pageNo
                }).then(res => {
                    reslove(true);
                    if (res.code === 200) {
                        total.value = res.data.total;
                        pageCount = res.data.pages;
                        if (pageNo == 1) {
                            lecturerData.value = res.data;
                        }
                        else {
                            lecturerData.value.items = lecturerData.value.items.concat(res.data.items);
                        }
                        if (pageCount > pageNo && !nums) {
                            pageNo++;
                            noMore.value = false;
                        }
                        else {
                            noMore.value = true;
                        }
                        if (total.value > 0) {
                            isEmpty.value = false;
                        }
                    }
                });
            });
        };
        // 滚动距离
        const scrollY = ref(0);
        const scrollFn = (e) => {
            scrollY.value = e.y;
        };
        /* getCourseList()
        getContentList() */
        /* 跳转 */
        let isApp = appPort();
        const resultJump = (type, item) => {
            /* READING:文章 LIVE:直播  PRODUCT:商城 COURSE:课程 COURSE_CONTENT:课程内容 */
            if (isApp) {
                if (type === 'READING') {
                    var url = `${hostPath}/news/detail?id=${item.readingId}`;
                    if (item.url !== '') {
                        url = item.url;
                    }
                    var data = {
                        dataId: item.readingId,
                        typeId: 'article_detail',
                        url: url
                    };
                    jumpModuleApp(data);
                }
                else if (type === 'LIVE') {
                    var data = {
                        dataId: item.liveId,
                        typeId: 'live_stream_detail',
                        url: `${hostPath}/live/broadcast/${item.liveId}`
                    };
                    jumpModuleApp(data);
                }
                else if (type === 'PRODUCT') {
                    var data = {
                        dataId: item.productId,
                        typeId: 'mall_detail',
                        url: `${hostPath}/mall/detail?productId=${item.productId}`
                    };
                    jumpModuleApp(data);
                }
                else if (type === 'COURSE_CONTENT') {
                    if (['NEW_OMO', 'TEAM'].includes(item.courseType)) {
                        /* 课节 任务 */
                        goToStudy('meeting', item.courseId, undefined, item.lessonId, item.taskId);
                    }
                    else {
                        goToStudy('album', item.courseId, undefined, item.lessonId, item.taskId);
                    }
                    return;
                }
                else {
                    if (['OPEN', 'OPEN_KNOWLEDGE'].includes(item.courseType)) {
                        goToStudy('album', item.courseId);
                        return;
                    }
                    /* 专辑非专辑 */
                    /* 非专辑： omo 共学营 老的训练营 学习班:无 */
                    if (['TEAM', 'NEW_OMO', 'OLD_OMO'].includes(item.courseType)) {
                        if (item.courseType == 'OLD_OMO') {
                            // 老训练营
                            jumpModuleApp({
                                dataId: item.courseId,
                                typeId: 'operation_detail'
                            });
                            return;
                        }
                        if (['NEW_OMO', 'TEAM'].includes(item.courseType)) {
                            jumpModuleApp({
                                dataId: item.courseId,
                                url: `${hostPath}/learn/courseguide/train/${item.courseId}`,
                                typeId: 'h5'
                            });
                        }
                    }
                    else {
                        /* 班期课 */
                        if (item.courseType === 'PERIOD') {
                            jumpModuleApp({
                                url: `${hostPath}/learn/courseguide/meeting/${item.courseId}`,
                                typeId: 'h5'
                            });
                            return;
                        }
                        else {
                            jumpModuleApp({
                                url: `${hostPath}/learn/courseguide/album/${item.courseId}`,
                                typeId: 'h5'
                            });
                            return;
                        }
                    }
                }
            }
            else {
                /* H5 */
                if (type === 'READING') {
                    var url = `${hostPath}/news/detail?id=${item.readingId}`;
                    if (item.url !== '') {
                        url = item.url;
                    }
                    location.assign(url);
                }
                else if (type === 'LIVE') {
                    location.assign(`${hostPath}/live/broadcast/${item.liveId}`);
                }
                else if (type === 'PRODUCT') {
                    location.assign(`${hostPath}/mall/detail?productId=${item.productId}`);
                }
                else if (type === 'COURSE_CONTENT') {
                    let { lessonId, taskId, courseId } = item;
                    if (['NEW_OMO', 'TEAM'].includes(item.courseType)) {
                        // goToStudy(
                        //   'meeting',
                        //   item.courseId,
                        //   undefined,
                        //   item.lessonId,
                        //   item.taskId
                        // )
                        location.assign(`${hostPath}/course/meeting/${courseId}?lessonId=${lessonId}&taskId=${taskId}`);
                    }
                    else {
                        // goToStudy('album', item.courseId)
                        location.assign(`${hostPath}/course/album/${item.courseId}`);
                    }
                    return;
                }
                else {
                    if (['OPEN', 'OPEN_KNOWLEDGE'].includes(item.courseType)) {
                        location.assign(`${hostPath}/course/album/${item.courseId}`);
                        return;
                    }
                    if (['TEAM', 'NEW_OMO', 'OLD_OMO'].includes(item.courseType)) {
                        if (item.courseType == 'OLD_OMO') {
                            // 老训练营
                            location.assign(`${hostPath}/training/detail?id=${item.courseId}`);
                            return;
                        }
                        if (['NEW_OMO', 'TEAM'].includes(item.courseType)) {
                            router.push({
                                name: 'courseGuidePage',
                                params: { type: 'train', id: item.courseId }
                            });
                        }
                    }
                    else {
                        if (item.courseType === 'PERIOD') {
                            router.push(`/courseguide/meeting/${item.courseId}`);
                        }
                        else {
                            router.push(`/courseguide/album/${item.courseId}`);
                        }
                    }
                }
            }
        };
        /* 去讲师详情页 */
        const goLecturer = (id) => {
            let isApp = appPort();
            if (isApp) {
                jumpModuleApp({
                    url: `${hostPath}/learn/expert/${id}`,
                    typeId: 'h5'
                });
            }
            else {
                location.assign(`${hostPath}/learn/expert/${id}`);
            }
        };
        expose({ getDatas });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["searchList", { blackTop: !searchModule.value && lecturerInfo.value?.expertId }])
            }, [
                _createElementVNode("div", {
                    style: { "position": "fixed", "/* top": "72px", "*/\n        left": "0px", "background": "#f5f5f7", "z-index": "99" },
                    ref: (_value, _refs) => {
                        _refs['tabBox'] = _value;
                    },
                    id: "queryForm"
                }, [
                    _withDirectives(_createElementVNode("div", _hoisted_1, [
                        _createVNode(BetterScroll, {
                            ref: (_value, _refs) => {
                                _refs['vipBs'] = _value;
                                vipBs.value = _value;
                            },
                            options: options,
                            loaded: loaded.value,
                            domStyle: {
                                position: 'relative',
                                height: '0.7rem'
                            },
                            wrapperStyle: {
                                width: tabW.value + 'rem'
                            }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("ul", {
                                    class: "condition_list typeList border-box p-lr32 condition_Tab",
                                    ref: (_value, _refs) => {
                                        _refs['tabDom'] = _value;
                                        tabDom.value = _value;
                                    }
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, key) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: key,
                                            class: _normalizeClass([{
                                                    active: item.navigationType === searchModule.value
                                                }, "tabs_item p-lr16 float-l font-32"]),
                                            onClick: ($event) => (moduleSearch(item))
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(item.navigationTypeName), 1)
                                        ], 10, _hoisted_2));
                                    }), 128))
                                ], 512)
                            ]),
                            _: 1
                        }, 8, ["loaded", "domStyle", "wrapperStyle"])
                    ], 512), [
                        [_vShow, tabList.value.length > 0]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                        _createVNode(BetterScroll, {
                            ref: (_value, _refs) => {
                                _refs['courseBs'] = _value;
                                courseBs.value = _value;
                            },
                            options: options,
                            loaded: loaded.value,
                            domStyle: {
                                position: 'relative',
                                height: '0.7rem'
                            },
                            wrapperStyle: {
                                width: courseW.value + 'rem'
                            }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("ul", {
                                    class: "condition_list border-box p-lr32 condition_Tab",
                                    ref: (_value, _refs) => {
                                        _refs['courseDom'] = _value;
                                        courseDom.value = _value;
                                    },
                                    style: { "margin-top": "5px" }
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseTabList.value, (item, key) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: key,
                                            class: _normalizeClass([{
                                                    active2: item.navigationType === searchCourse.value,
                                                    radius: detailList.value?.length
                                                }, "tabs_item p-lr16 float-l flex-c font-28"]),
                                            onClick: _withModifiers(($event) => (courseSearch(item)), ["stop"])
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(item.navigationTypeName), 1)
                                        ], 10, _hoisted_4));
                                    }), 128))
                                ], 512)
                            ]),
                            _: 1
                        }, 8, ["loaded", "domStyle", "wrapperStyle"])
                    ], 512), [
                        [_vShow, courseTabList.value.length > 0]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_5, [
                        _createVNode(BetterScroll, {
                            ref: (_value, _refs) => {
                                _refs['detailBs'] = _value;
                                detailBs.value = _value;
                            },
                            options: options,
                            loaded: loaded.value,
                            domStyle: {
                                position: 'relative',
                                height: '0.82rem'
                            },
                            wrapperStyle: {
                                width: detailW.value + 'rem'
                            }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("ul", {
                                    class: "condition_list subTypeList border-box p-lr32 condition_Tab",
                                    ref: (_value, _refs) => {
                                        _refs['detailDom'] = _value;
                                        detailDom.value = _value;
                                    }
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailList.value, (item, key) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: key,
                                            class: _normalizeClass([{ active: item.navigationType === searchDetail.value }, "p-lr16 float-l font-24"]),
                                            onClick: _withModifiers(($event) => (detailSearch(item)), ["stop"])
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(item.navigationTypeName), 1)
                                        ], 10, _hoisted_6));
                                    }), 128))
                                ], 512)
                            ]),
                            _: 1
                        }, 8, ["loaded", "domStyle", "wrapperStyle"])
                    ], 512), [
                        [_vShow, detailList.value.length > 0]
                    ])
                ], 512),
                _createVNode(BetterScroll, {
                    ref: (_value, _refs) => {
                        _refs['listRef'] = _value;
                        listRef.value = _value;
                    },
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: false,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: true
                    },
                    loaded: isLoaded.value,
                    onUpLoad: getDatas,
                    domStyle: {
                        position: 'relative',
                        height: `calc(100vh - 1.4rem)`
                    },
                    onScrollFn: scrollFn
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "search-content",
                            style: _normalizeStyle({ marginTop: tabHeight.value + 'rem' })
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass({
                                    topContent: !searchModule.value && lecturerInfo.value?.expertId ? true : ''
                                })
                            }, [
                                _withDirectives(_createElementVNode("div", {
                                    class: "lecturerTop",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (goLecturer(lecturerInfo.value?.expertId)), ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("img", {
                                            src: lecturerInfo.value?.cover
                                        }, null, 8, _hoisted_8),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("span", {
                                                class: "expert font-36 font-w500",
                                                innerHTML: lecturerInfo.value?.expertName
                                            }, null, 8, _hoisted_10),
                                            _hoisted_11,
                                            _createElementVNode("span", {
                                                class: "font-24",
                                                innerHTML: lecturerInfo.value?.hospitalName
                                            }, null, 8, _hoisted_12)
                                        ])
                                    ]),
                                    _createElementVNode("div", {
                                        class: "hospitalDetail text-ell2 wordLine",
                                        style: { "white-space": "pre-wrap", "max-height": "0.8rem" },
                                        innerHTML: lecturerInfo.value?.description?.replace(/\r\n/g, '</br>')
                                    }, null, 8, _hoisted_13)
                                ], 512), [
                                    [_vShow, !searchModule.value && lecturerInfo.value?.expertId]
                                ]),
                                _withDirectives(_createElementVNode("ul", {
                                    class: _normalizeClass(["courseList border-box", { 'white-bg': !searchModule.value, 'p-lr20': !searchModule.value }])
                                }, [
                                    _createElementVNode("div", _hoisted_14, [
                                        (!searchModule.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _hoisted_16,
                                                _createElementVNode("div", {
                                                    class: "totalNum flex-c",
                                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (moduleSearch('COURSE')), ["stop"]))
                                                }, [
                                                    _hoisted_17,
                                                    _createElementVNode("span", _hoisted_18, _toDisplayString(courseData.value.total), 1),
                                                    _hoisted_19,
                                                    _hoisted_20
                                                ])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _hoisted_22,
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(courseData.value.total), 1),
                                                _hoisted_24
                                            ]))
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseData.value.items, (list, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "flex",
                                            key: index,
                                            onClick: ($event) => (resultJump('COURSE', list))
                                        }, [
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("img", {
                                                    src: list.cover
                                                }, null, 8, _hoisted_27),
                                                (list.courseTypeName)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(list.courseTypeName), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_29, [
                                                _createElementVNode("div", {
                                                    class: "title text-ell2 font-32 wordLine",
                                                    innerHTML: list.courseName
                                                }, null, 8, _hoisted_30),
                                                _withDirectives(_createElementVNode("div", _hoisted_31, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.experts, (expert, key) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            class: "expert gray-6",
                                                            key: key,
                                                            innerHTML: expert.expertName
                                                        }, null, 8, _hoisted_32));
                                                    }), 128)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.hospitals, (hospital, key) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            class: "hospital gray-9",
                                                            key: key,
                                                            innerHTML: hospital.hospitalName
                                                        }, null, 8, _hoisted_33));
                                                    }), 128))
                                                ], 512), [
                                                    [_vShow, list.experts.length > 0 || list.hospitals.length > 0]
                                                ]),
                                                _createElementVNode("div", _hoisted_34, [
                                                    (!['TEAM', 'OLD_OMO', 'NEW_OMO', 'PERIOD'].includes(list.courseType))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                            _withDirectives(_createElementVNode("div", _hoisted_36, [
                                                                _hoisted_37,
                                                                _createTextVNode(" " + _toDisplayString(list.lessonCount) + "个课时 ", 1)
                                                            ], 512), [
                                                                [_vShow, list.lessonCount]
                                                            ]),
                                                            _withDirectives(_createElementVNode("div", _hoisted_38, [
                                                                _hoisted_39,
                                                                _createTextVNode(" " + _toDisplayString(Math.ceil(list.length / 60)) + "分钟 ", 1)
                                                            ], 512), [
                                                                [_vShow, list.length]
                                                            ])
                                                        ]))
                                                        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                            _hoisted_41,
                                                            _createTextVNode(" " + _toDisplayString(list.startedAt) + " 开营 ", 1)
                                                        ], 512)), [
                                                            [_vShow, list.startedAt]
                                                        ])
                                                ])
                                            ])
                                        ], 8, _hoisted_25));
                                    }), 128))
                                ], 2), [
                                    [_vShow,
                                        (searchModule.value === 'COURSE' || !searchModule.value) &&
                                            courseData.value.total > 0
                                    ]
                                ])
                            ], 2),
                            _withDirectives(_createElementVNode("ul", {
                                class: _normalizeClass(["courseList border-box", { 'white-bg': !searchModule.value, 'p-lr20': !searchModule.value }])
                            }, [
                                _createElementVNode("div", _hoisted_42, [
                                    (!searchModule.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                            _hoisted_44,
                                            _createElementVNode("div", {
                                                class: "totalNum flex-c",
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (moduleSearch('COURSE_CONTENT')), ["stop"]))
                                            }, [
                                                _hoisted_45,
                                                _createElementVNode("span", _hoisted_46, _toDisplayString(courseContent.value.total), 1),
                                                _hoisted_47,
                                                _hoisted_48
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                            _hoisted_50,
                                            _createElementVNode("span", _hoisted_51, _toDisplayString(courseContent.value.total), 1),
                                            _hoisted_52
                                        ]))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseContent.value.items, (list, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "flex",
                                        key: index,
                                        onClick: ($event) => (resultJump('COURSE_CONTENT', list))
                                    }, [
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("img", {
                                                src: list.cover
                                            }, null, 8, _hoisted_55),
                                            (list.courseTypeName)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(list.courseTypeName), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_57, [
                                            _createElementVNode("div", _hoisted_58, [
                                                _hoisted_59,
                                                _hoisted_60,
                                                _createElementVNode("span", {
                                                    innerHTML: list.videoName
                                                }, null, 8, _hoisted_61)
                                            ]),
                                            _createElementVNode("div", _hoisted_62, [
                                                _hoisted_63,
                                                _createElementVNode("span", {
                                                    class: "expert gray-9",
                                                    innerHTML: list.courseName
                                                }, null, 8, _hoisted_64)
                                            ]),
                                            (['TEAM', 'NEW_OMO', 'OLD_OMO'].includes(list.courseType) &&
                                                list.lessonName)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                    _hoisted_66,
                                                    _createElementVNode("span", {
                                                        class: "expert gray-9",
                                                        innerHTML: list.lessonName
                                                    }, null, 8, _hoisted_67)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (list.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _hoisted_70,
                                                        _createTextVNode(" " + _toDisplayString(Math.ceil(list.length / 60)) + "分钟 ", 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_53));
                                }), 128))
                            ], 2), [
                                [_vShow,
                                    (searchModule.value === 'COURSE_CONTENT' || !searchModule.value) &&
                                        courseContent.value.total > 0
                                ]
                            ]),
                            _withDirectives(_createElementVNode("ul", {
                                class: _normalizeClass(["courseList border-box", { 'white-bg': !searchModule.value, 'p-lr20': !searchModule.value }])
                            }, [
                                _createElementVNode("div", _hoisted_71, [
                                    (!searchModule.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                            _hoisted_73,
                                            _createElementVNode("div", {
                                                class: "totalNum flex-c",
                                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (moduleSearch('EXPERT')), ["stop"]))
                                            }, [
                                                _hoisted_74,
                                                _createElementVNode("span", _hoisted_75, _toDisplayString(lecturerData.value.total), 1),
                                                _hoisted_76,
                                                _hoisted_77
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                            _hoisted_79,
                                            _createElementVNode("span", _hoisted_80, _toDisplayString(lecturerData.value.total), 1),
                                            _hoisted_81
                                        ]))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lecturerData.value.items, (list, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "flex lecturer",
                                        key: index,
                                        onClick: _withModifiers(($event) => (goLecturer(list.expertId)), ["stop"])
                                    }, [
                                        _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("img", {
                                                src: list.cover,
                                                alt: ""
                                            }, null, 8, _hoisted_84)
                                        ]),
                                        _createElementVNode("div", _hoisted_85, [
                                            _createElementVNode("div", _hoisted_86, [
                                                _createElementVNode("div", _hoisted_87, [
                                                    _createElementVNode("span", {
                                                        style: { "display": "block" },
                                                        class: "title font-32 expert text-overflow",
                                                        innerHTML: list.expertName
                                                    }, null, 8, _hoisted_88),
                                                    _createElementVNode("span", {
                                                        class: "hospitalName font-24",
                                                        innerHTML: list.hospitalName
                                                    }, null, 8, _hoisted_89)
                                                ]),
                                                _hoisted_90
                                            ]),
                                            _createElementVNode("div", {
                                                class: "lecturerBottom font-28 text-ell2 wordLine",
                                                innerHTML: list.description?.replace(/\r\n/g, '</br>')
                                            }, null, 8, _hoisted_91)
                                        ])
                                    ], 8, _hoisted_82));
                                }), 128))
                            ], 2), [
                                [_vShow,
                                    (searchModule.value === 'EXPERT' || !searchModule.value) &&
                                        lecturerData.value.total > 0
                                ]
                            ]),
                            _withDirectives(_createElementVNode("ul", {
                                class: _normalizeClass(["courseList border-box", { 'white-bg': !searchModule.value, 'p-lr20': !searchModule.value }])
                            }, [
                                _createElementVNode("div", _hoisted_92, [
                                    (!searchModule.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                            _hoisted_94,
                                            _createElementVNode("div", {
                                                class: "totalNum flex-c",
                                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (moduleSearch('READING')), ["stop"]))
                                            }, [
                                                _hoisted_95,
                                                _createElementVNode("span", _hoisted_96, _toDisplayString(articleData.value.total), 1),
                                                _hoisted_97,
                                                _hoisted_98
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                            _hoisted_100,
                                            _createElementVNode("span", _hoisted_101, _toDisplayString(articleData.value.total), 1),
                                            _hoisted_102
                                        ]))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleData.value.items, (list, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "flex",
                                        key: index,
                                        onClick: ($event) => (resultJump('READING', list))
                                    }, [
                                        _createElementVNode("div", _hoisted_104, [
                                            _createElementVNode("img", {
                                                src: list.cover,
                                                alt: ""
                                            }, null, 8, _hoisted_105)
                                        ]),
                                        _createElementVNode("div", _hoisted_106, [
                                            _createElementVNode("div", {
                                                class: "title text-ell2 font-32 wordLine",
                                                innerHTML: list.readingName
                                            }, null, 8, _hoisted_107),
                                            (list.startingTime)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                    _createElementVNode("span", _hoisted_109, _toDisplayString(list.startingTime), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (list.viewCount)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                    _createElementVNode("div", _hoisted_111, [
                                                        _hoisted_112,
                                                        _createElementVNode("span", _hoisted_113, _toDisplayString(list.viewCount) + "人浏览", 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_103));
                                }), 128))
                            ], 2), [
                                [_vShow,
                                    (searchModule.value === 'READING' || !searchModule.value) &&
                                        articleData.value.total > 0
                                ]
                            ]),
                            _withDirectives(_createElementVNode("ul", {
                                class: _normalizeClass(["courseList border-box", { 'white-bg': !searchModule.value, 'p-lr20': !searchModule.value }])
                            }, [
                                _createElementVNode("div", _hoisted_114, [
                                    (!searchModule.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                            _hoisted_116,
                                            _createElementVNode("div", {
                                                class: "totalNum flex-c",
                                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (moduleSearch('LIVE')), ["stop"]))
                                            }, [
                                                _hoisted_117,
                                                _createElementVNode("span", _hoisted_118, _toDisplayString(liveData.value.total), 1),
                                                _hoisted_119,
                                                _hoisted_120
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                            _hoisted_122,
                                            _createElementVNode("span", _hoisted_123, _toDisplayString(liveData.value.total), 1),
                                            _hoisted_124
                                        ]))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveData.value.items, (list, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "flex",
                                        key: index,
                                        onClick: ($event) => (resultJump('LIVE', list))
                                    }, [
                                        _createElementVNode("div", _hoisted_126, [
                                            _createElementVNode("img", {
                                                src: list.cover,
                                                style: { "height": "100%", "width": "252px" }
                                            }, null, 8, _hoisted_127),
                                            _createElementVNode("div", _hoisted_128, [
                                                (list.statusName === '直播中')
                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_129))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("span", null, _toDisplayString(list.statusName), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_130, [
                                            _createElementVNode("div", {
                                                class: "title text-ell2 font-32 wordLine",
                                                innerHTML: list.liveName
                                            }, null, 8, _hoisted_131),
                                            _createElementVNode("div", _hoisted_132, [
                                                _createElementVNode("span", {
                                                    class: "expert gray-6",
                                                    innerHTML: list.expertName
                                                }, null, 8, _hoisted_133),
                                                _createElementVNode("span", {
                                                    class: "hospital gray-9",
                                                    innerHTML: list.hospitalName
                                                }, null, 8, _hoisted_134)
                                            ]),
                                            (list.startingTime)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                                    _createElementVNode("div", _hoisted_136, [
                                                        _hoisted_137,
                                                        _createTextVNode(" " + _toDisplayString(list.startingTime), 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_125));
                                }), 128))
                            ], 2), [
                                [_vShow,
                                    (searchModule.value === 'LIVE' || !searchModule.value) && liveData.value.total > 0
                                ]
                            ]),
                            _withDirectives(_createElementVNode("ul", {
                                class: _normalizeClass(["courseList border-box", { 'white-bg': !searchModule.value, 'p-lr20': !searchModule.value }])
                            }, [
                                _createElementVNode("div", _hoisted_138, [
                                    (!searchModule.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                            _hoisted_140,
                                            _createElementVNode("div", {
                                                class: "totalNum flex-c",
                                                onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (moduleSearch('PRODUCT')), ["stop"]))
                                            }, [
                                                _hoisted_141,
                                                _createElementVNode("span", _hoisted_142, _toDisplayString(mallData.value.total), 1),
                                                _hoisted_143,
                                                _hoisted_144
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                            _hoisted_146,
                                            _createElementVNode("span", _hoisted_147, _toDisplayString(mallData.value.total), 1),
                                            _hoisted_148
                                        ]))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mallData.value.items, (list, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        class: "flex",
                                        key: index,
                                        onClick: ($event) => (resultJump('PRODUCT', list))
                                    }, [
                                        _createElementVNode("div", _hoisted_150, [
                                            _createElementVNode("img", {
                                                src: list.cover
                                            }, null, 8, _hoisted_151)
                                        ]),
                                        _createElementVNode("div", _hoisted_152, [
                                            _createElementVNode("div", {
                                                class: "title text-ell2 font-32 wordLine",
                                                innerHTML: list.productName
                                            }, null, 8, _hoisted_153),
                                            _createElementVNode("div", _hoisted_154, [
                                                _createElementVNode("span", _hoisted_155, "￥" + _toDisplayString(list.price ? list.price : 0), 1),
                                                _createElementVNode("span", _hoisted_156, "￥" + _toDisplayString(list.originalPrice ? list.originalPrice : 0), 1)
                                            ]),
                                            (list.memberPrice)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_157, " 会员价：" + _toDisplayString(list.memberPrice), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_149));
                                }), 128))
                            ], 2), [
                                [_vShow,
                                    (searchModule.value === 'PRODUCT' || !searchModule.value) && mallData.value.total > 0
                                ]
                            ])
                        ], 4),
                        _withDirectives(_createVNode(Empty, null, null, 512), [
                            [_vShow, isLoaded.value && __props.searchText && isEmpty.value && _unref(total) === 0]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_158, "没有更多了", 512), [
                            [_vShow, noMore.value && !isEmpty.value]
                        ])
                    ]),
                    _: 1
                }, 8, ["loaded", "domStyle"]),
                _createVNode(FeedBack, {
                    searchText: __props.searchText,
                    showFeed: showFeed.value
                }, null, 8, ["searchText", "showFeed"])
            ], 2));
        };
    }
});
